import * as React from 'react'

import './styles.sass'

function Auth({ children }) {
  return <div className="pvt-auth-wrapper custom">{children}</div>
}

export default Auth
